/**
 * Company roles as identity names them. The client knows their NAMES and nothing else: the rank
 * ladder lives in identity, which expands it onto the token and onto `effectiveRoles` (VT,
 * 2026-09-07; `task-adopt-effective-roles.md`). Nothing here ranks, sorts or infers a role.
 */

/** ACCOUNT_MANAGER → "Account Manager". No label map, so the list can never go stale. */
export function roleLabel(name: string): string {
  return name
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map(w => w[0].toUpperCase() + w.slice(1))
    .join(' ');
}

/** The two role lists identity puts on an employee: `roles` is granted, `effectiveRoles` is the ladder under them. */
export interface RoleHolder {
  roles?: readonly string[] | null;
  effectiveRoles?: readonly string[] | null;
}

/**
 * "May this account do X?" reads `effectiveRoles` and only that: identity's own answer to what
 * the account covers, so the screen and the gate agree. For a company employee (juno) it is the
 * ladder expanded onto the token; for salon staff (argus) it is the roles whose every scope the
 * token carries. `roles` is what was granted: label with it, edit it, never gate on it. An
 * executive's `roles` is `["EXECUTIVE"]` while the gate it faces reads `ACCOUNT_MANAGER`. An
 * identity behind 2026-09-07 sends no `effectiveRoles`, and every guard reads false there; there
 * is no fallback to `roles` on purpose, so no guard ever reads the granted list.
 */
export function holdsRole(user: RoleHolder | null | undefined, role: string): boolean {
  return (user?.effectiveRoles ?? []).includes(role);
}
